import { JSX } from 'react';
import './Text.scss';

const Text = ({
  children,
  type,
  size = 'standard',
  className = '',
}: {
  children?: JSX.Element | JSX.Element[] | string | string[] | (string | JSX.Element)[];
  type: 'header' | 'subheader' | 'body' | 'callout';
  size?: 'standard' | 'small';
  className?: string;
}) => {
  if (type === 'header') return <h1 className={`${size} ${className}`}>{children}</h1>;
  if (type === 'subheader') return <h2 className={`${size} ${className}`}>{children}</h2>;

  return <p className={`${type} ${size} ${className}`}>{children}</p>;
};

export default Text;
